module.exports = __webpack_public_path__ + "media/opengl-animation.618fb518.mp4";